import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from '../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { AuditTrayDto, UserStaffDetailDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-audittray-container',
  templateUrl: './audittray-container.component.html',
  styleUrls: ['./audittray-container.component.scss']
})
export class AudittrayContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  audittrays$: Observable<AuditTrayDto[]>;
  actionedstaff$: Observable<UserStaffDetailDto[]>;
  loading: boolean;
  isLoadingAudittray$: Observable<boolean>;
  isLoadingActionedstaff$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingAudittray$ = this.gatwayFacade.isLoadingGateway("AuditTray");
    this.isLoadingActionedstaff$ = this.gatwayFacade.isLoadingGateway("UserStaffDetail");

    this.audittrays$ = this.gatwayFacade.loadGateway("AuditTray");
     this.actionedstaff$ = this.gatwayFacade.loadGateway("UserStaffDetail");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAudittray(deletedValue: any) {
    this.gatwayFacade.remove("AuditTray", deletedValue);
  }


// this method control both the create and update

  onSubmitAudittray(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.AuditTrays;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllAuditTray = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllAuditTray.push(pullData[i]);
    }
  }

// check if the addAllAuditTray array is not empty, then dispatch the data to the store
   if(addAllAuditTray.length > 0) {
    this.gatwayFacade.add('AuditTray', addAllAuditTray);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('AuditTray', allUpdates, ['id']);
  }

   }


}
